(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["avela-klarna"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('avela-klarna-checkout')) {
  customElements.define('avela-klarna-checkout', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.addEventListener('click', async (event) => {
        const button = event.target.closest('button');
        if (!button || !this.dataset.productForm || this.busy) return;
        const form = document.getElementById(this.dataset.productForm);
        const error = this.querySelector('[role="alert"]');
        if (!form) { error.hidden = false; return; }
        if (!form.reportValidity()) return;
        const data = new FormData(form);
        if (!data.get('id')) { error.hidden = false; return; }
        this.busy = true;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        error.hidden = true;
        try {
          const response = await fetch(this.dataset.addUrl, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: data
          });
          const result = await response.json();
          if (!response.ok || result.status >= 400) throw new Error('cart');
          window.location.assign(this.dataset.checkoutUrl);
        } catch {
          error.hidden = false;
          button.disabled = false;
          button.removeAttribute('aria-busy');
          this.busy = false;
        }
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
